import media_utility from '../store/media_utility';
import utility from '../store/utility';
import request from "./curl";
import confirmation_dialog from "../components/confirmation_dialog";

export default {
  name: "attachment_file_preview",
  props:['showDialog', 'attachment_file_preview_data'],
  components: {
    confirmation_dialog
  },
  data: () => ({
    file_download_loader:false,
    delete_confirmation_dailog:false,
    snackbar:false,
    err_msg:'',
  }),
  computed: {
    dialog:{
      get:function(){
        return this.showDialog;
      },
      set:function(value){
        this.$emit("dialogClose", value);
      }
    },
    userData() {
      return this.$store.getters.userData;
    },
    getClientDeviceHeight(){
      return this.$store.getters.getClientDeviceHeight;
    }
  },
  mounted() {
  },
  methods: {
    /**
     * file_download
     */
    async file_download(content_message_data){
      this.file_download_loader = true;
      let res = await media_utility.file_download(content_message_data);
      if(res){
        this.file_download_loader = false;
      }
    },
    /**
     * cancel_download
     */
    cancel_download(){
      media_utility.cancel_download();
      this.file_download_loader = false;
    },
    /**
     * media_delete_dialog
     */
    media_delete_dialog(){
      this.delete_confirmation_dailog = true;
    },
    /**
     * media_delete
     */
    media_delete(){
      if(this.attachment_file_preview_data.user_id == this.userData.user_id){
        let post_data = new FormData();
        post_data.append("chat_user_id", this.userData.user_id);
        post_data.append("media_ids", JSON.stringify([this.attachment_file_preview_data.id]));
        request.curl(this, "media_delete", post_data)
        .then(response => {
          if(response.resp_status){
            this.$emit('media_delete_from_preview', this.attachment_file_preview_data);
            this.dialog = false;
          }
        });
      }
      else{
        this.snackbar = true;
        this.err_msg = 'You can not delete this media. you are not owner';
        this.dialog = false;
      }
    },
    /**
    * bytesToSize
    */
    bytesToSize(bytes) {
      return media_utility.bytesToSize(bytes);
    },
    /**
    * msg_time
    */
    msg_time(timestamp) {
      return utility.get_message_datetime(timestamp, 'DD/MM/YYYY', false);
    },
  }
}
